import { View } from 'react-native';
export default View;
//# sourceMappingURL=FullWindowOverlay.web.js.map